import React, { useEffect, useState, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import axios from 'axios';
import { getHeaders } from '../../request';
import Imagens from '../anexos/imagens';
import { SITUACAO_LAUDO } from './constantes';
import { temPermissaoRBAC, temPermissaoRede } from '../../secutity/acl';
import Priorizar from './priorizar';
import Invalidar from './invalidar';
import { PERMISSOES } from '../../common/Constants';
import { open, configure } from '../../reducers/alerta';
import {
    SttTextItem,
    SttCircularProgress,
    SttNotification,
    SttAlertTitle,
    SttTranslateHook,
    SttCtrlP
} from '@stt-componentes/core';
import { SttContentDrawer } from '@stt-componentes/core-v2';
import { Util } from '@stt-utilitarios/core';
import { NotificationManager } from 'react-notifications';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip';
import { SECOES, REACT_KEYS } from './fieldNames';

const useStyles = makeStyles(theme => ({
    carregando: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%'
    },
    notificationContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    notification: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
	},
	protocolo: {
		display: 'flex',
		gap: theme.spacing(2),
		alignItems: 'center'
	},
	fileCopyIcon: {
		fontSize: '1.2em',
		cursor: 'pointer',
		color: '#0A6FB8'
	}
}));

const DadosExame = (props) => {
    const { id, imprimirFn, imprimirProtocoloFn, imprimirTermoFn, voltarFn = false } = props;

    const user = useSelector(state => state.index.user);
    const classes = useStyles();
    const dispatch = useDispatch();
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const drawerRef = useRef();

    const EEG_API_BASE_URL = global.gConfig.url_base_eeg;
    const [exame, setExame] = useState(null);
	const [textoTooltip, setTextoTooltip] = useState(strings.copiar);

    const [priorizar, setPriorizar] = useState(false);
    const [invalidar, setInvalidar] = useState(false);
    const [permissaoBtns, setPermissaoBtns] = useState([]);
    
    useEffect(() => {

        if (user.perfisRBAC && exame) {
            let rede;
            user.perfisRBAC.forEach(p => {
                p.redes && p.redes.forEach(r => {
                    if (r.id === exame.exame.id_rede_telemedicina) {
                        rede = r;
                    }
                });
            });
            if (rede) {
                setPermissaoBtns([
                    temPermissaoRede(rede[0], PERMISSOES.INVALIDAR_EXAME),
                    temPermissaoRede(rede[0], PERMISSOES.PRIORIZAR_EXAME)
                ]);
            }
        }
    }, [user, exame]);

    useEffect(() => {
        if (id) {
            axios
                .get(`${EEG_API_BASE_URL}/exame/${id}`, { headers: getHeaders() })
                .then((response) => {
                    const { data } = response;
                    setExame(data);
                })
                .catch(err => {
                    const { response } = err;
                    let msg = strings.mensagemErroGeral;
                    let titulo = strings.erro;
                    let arrMensagem = [];
                    if (response) {
                        const { data } = response;
                        titulo = data.message;
                        data.errors.forEach(error => {
                            arrMensagem.push(`- ${error.message}`);
                        });
                        msg = arrMensagem.join('\n');
                    }

                    const alertConfig = {
                        title: titulo,
                        message: msg,
                        type: 'error',
                        open: true,
                        options: [
                            {
                                title: strings.ok,
                                onClick: () => {
                                    dispatch(open(false));
                                    voltarFn();
                                }
                            }
                        ],
                        onClose: () => {
                            dispatch(open(false));
                            voltarFn();
                        }
                    };
                    dispatch(configure(alertConfig));
                });
        }
    }, [id]);

    const callbackImpedirImpressao = () => {
		if (exame.exame.valido) {
			imprimirFn(id);
		} else {
		NotificationManager.error(strings.impressaoDesabilitada);
		}
	};

    return (
        <>
            {
                !exame
                    ?
                    <div className={classes.carregando}>
                        <SttCircularProgress color="primary" />
                    </div>
                    :
                <>
                    <SttContentDrawer
                        titulo={exame.exame.descricao_exame}
                        onClickVoltar={voltarFn}
                        ref={drawerRef}
                        secoesErro={[SECOES.DADOS_DO_PACIENTE, SECOES.DADOS_DO_EXAME, SECOES.INDICACAO_CLINICA, SECOES.OUTRAS_INFORMACOES, SECOES.LAUDO]}
                        botoes={[
                            {
                                key: REACT_KEYS.BTN_IMPRIMIR,
                                descricao: strings.imprimir,
                                type: 'button',
                                variant: 'contained',
                                color: 'primary',
                                show: exame.exame.valido,
                                onClick: () => imprimirFn(id),
                            },
                            {
                                key: REACT_KEYS.BTN_PROTOCOLO,
                                descricao: strings.protocolo,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show: exame.exame.valido,
                                onClick: () =>
                                    imprimirProtocoloFn({
                                        ...exame.exame,
                                        id: exame.exame.id_exame,
                                    }),
                            },
                            {
                                key: REACT_KEYS.BTN_PRIORIZAR,
                                descricao: strings.priorizar,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show:
                                    (permissaoBtns[1] ||
                                        (permissaoBtns[1] === undefined &&
                                            temPermissaoRBAC(user, PERMISSOES.PRIORIZAR_EXAME))) &&
                                    exame.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO &&
                                    exame.exame.valido,
                                onClick: () => setPriorizar(true),
                            },
                            {
                                key: REACT_KEYS.BTN_INVALIDAR,
                                descricao: strings.invalidar,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show:
                                    (((permissaoBtns[0] ||
                                        (permissaoBtns[0] === undefined &&
                                            temPermissaoRBAC(user, PERMISSOES.INVALIDAR_EXAME))) &&
                                        exame.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO) ||
                                        (temPermissaoRBAC(
                                            user,
                                            PERMISSOES.INVALIDAR_EXAME_LAUDADO
                                        ) &&
                                            exame.exame.situacao_laudo === SITUACAO_LAUDO.COM_LAUDO)) &&
                                    exame.exame.valido,
                                onClick: () => setInvalidar(true),
                            },
                            {
                                key: REACT_KEYS.BTN_TERMO,
                                descricao: strings.imprimirTermo,
                                type: 'button',
                                variant: 'contained',
                                color: 'secondary',
                                show: exame.exame.valido,
                                onClick: () => imprimirTermoFn(exame.exame),
                            }
                        ]}
                        conteudo={[
                            {
                                key: REACT_KEYS.SEC_DADOS_DO_PACIENTE,
                                id: SECOES.DADOS_DO_PACIENTE,
                                titulo: strings.paciente,
                                show: true,
                                children: (
                                    <div>
                                        <SttTextItem title={strings.nome} content={exame.exame.nome_paciente} />
                                        <SttTextItem title={strings.dataNascimento} content={exame.exame.data_nascimento_paciente_formatada} />
                                        <SttTextItem title={strings.sexo} content={exame.exame.sexo_paciente} />
                                        {exame.indicacao?.peso_paciente && <SttTextItem title={strings.peso} content={`${exame.indicacao.peso_paciente} kg`} />}
                                        {exame.indicacao?.altura_paciente && <SttTextItem title={strings.altura} content={`${exame.indicacao.altura_paciente} cm`} />}
                                        <SttTextItem title={strings.idade} content={`${exame.exame.idade_paciente} anos`} />
                                        {exame.exame.cartao_sus_paciente && <SttTextItem title={strings.cns} content={exame.exame.cartao_sus_paciente} />}
                                        {exame.exame.cpf_paciente && <SttTextItem title={strings.cpf} content={Util.util.adicionarMascara(exame.exame.cpf_paciente, '000.000.000-00')} />}
                                    </div>                                    
                                ),
                            },
                            {
                                key: REACT_KEYS.SEC_DADOS_DO_EXAME,
                                id: SECOES.DADOS_DO_EXAME,
                                titulo: strings.dadosExame,
                                show: true,
                                children: (
                                    <div>
                                        <SttTextItem title={strings.modalidade} content={exame.exame.descricao_modalidade} />
                                        <SttTextItem title={strings.dataExame} content={`${exame.exame.data_exame} ${global.gConfig.sufixo_data_hora}`} />
                                    <div className={classes.protocolo}>
                                        <SttTextItem
                                            title={strings.protocolo}
                                            content={exame.exame.protocolo_rctm}
                                        />
                                        <Tooltip
                                            title={textoTooltip}
                                            arrow
                                            onClick={() => {
                                                navigator.clipboard.writeText(exame.exame.protocolo_rctm);
                                                setTextoTooltip(strings.protocoloCopiado);
                                            }}
                                            onClose={(e) => setTextoTooltip(strings.copiar)}
                                        >
                                            <FileCopyIcon className={classes.fileCopyIcon} />
                                        </Tooltip>
                                    </div>                                    
                                        <SttTextItem title={strings.requisicao} content={exame.exame.requisicao} />
                                        <SttTextItem title={strings.instituicao} content={exame.exame.nome_instituicao} />
                                        {exame.exame.nome_medico_solicitante && <SttTextItem title={strings.medicoSolicitante} content={exame.exame.nome_medico_solicitante} />}
                                        {exame.exame.nome_medico_executor && <SttTextItem title={strings.medicoExecutor} content={exame.exame.nome_medico_executor} />}
                                    </div>
                                ),
                            },
                            {
                                key: REACT_KEYS.SEC_INDICACAO_CLINICA,
                                id: SECOES.INDICACAO_CLINICA,
                                titulo: strings.indicacaoClinica,
                                show: exame.indicacao,
                                children: (
                                    <div>
                                        {exame.indicacao?.antecedentes && <SttTextItem title={strings.antecedentes} content={exame.indicacao.antecedentes} />}
                                        {exame.indicacao?.indicacao_exame && <SttTextItem title={strings.indicacaoExame} content={exame.indicacao.indicacao_exame} />}
                                        {exame.indicacao?.historia_clinica && <SttTextItem title={strings.historiaClinica} content={exame.indicacao.historia_clinica} />}
                                        {exame.indicacao?.medicamentos_em_uso && <SttTextItem title={strings.medicamentosEmUso} content={exame.indicacao.medicamentos_em_uso} />}
                                        {exame.indicacao?.resultado_exames_anteriores && <SttTextItem title={strings.resultadosExamesAnteriores} content={exame.indicacao.resultado_exames_anteriores} />}
                                    </div>
                                ),
                            },
                            {
                                key: REACT_KEYS.SEC_OUTRAS_INFORMACOES,
                                id: SECOES.OUTRAS_INFORMACOES,
                                titulo: strings.outrasInformacoes,
                                show: exame.exame.observacao_tecnica?.trim(),
                                children: (
                                    <div>
                                        {exame.exame.observacao_tecnica && <SttTextItem title={strings.observacaoTecnica} content={exame.exame.observacao_tecnica} />}
                                    </div>
                                )
                            },
                            {
                                key: REACT_KEYS.SEC_LAUDO,
                                id: SECOES.LAUDO,
                                titulo: strings.laudo,
                                show: temPermissaoRBAC(user, PERMISSOES.VISUALIZAR_LAUDO) && exame.laudo,
                                children: (
                                    <div dangerouslySetInnerHTML={{ __html: exame.laudo }}></div>
                                )
                            },
                            {
                                key: REACT_KEYS.SEC_INVALIDO,
                                id: SECOES.INVALIDO,
                                titulo: strings.invalido,
                                show: !exame.exame?.valido,
                                children: (
                                    <SttNotification severity="info" className={classes.notification}>
                                        <SttAlertTitle>{strings.exameInvalidado}</SttAlertTitle>
                                            <div className={classes.notificationContent}>
                                                <span>{`${strings.motivo}: ${exame.exame.motivo_invalidacao}`}</span>
                                                <span>{`${strings.responsavel}: ${exame.exame.responsavel_invalidacao}`}</span>
                                                <span>{`${strings.data}: ${exame.exame.data_invalidacao} ${global.gConfig.sufixo_data_hora}`}</span>
                                            </div>
                                    </SttNotification>
                                ),
                            },
                            {
                                key: REACT_KEYS.SEC_IMAGENS,
                                id: SECOES.IMAGENS,
                                titulo: strings.imagens,
                                show: temPermissaoRBAC(user, PERMISSOES.VISUALIZAR_IMAGEM),
                                children: (
                                    <Imagens idExame={id} />
                                ),
                            },
                        ]}
                    />

                    {
                        (permissaoBtns[1] ||
                            (permissaoBtns[1] === undefined && temPermissaoRBAC(user, PERMISSOES.PRIORIZAR_EXAME))) &&
                        priorizar && exame.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO && exame.exame.valido &&
                        <Priorizar priorizar={priorizar} setPriorizar={setPriorizar} idExame={id} idInstituicao={exame.exame.id_instituicao} callback={voltarFn} />
                    }
                    {
                        (((permissaoBtns[0] ||
                            (permissaoBtns[0] === undefined && temPermissaoRBAC(user, PERMISSOES.INVALIDAR_EXAME))) &&
                            exame.exame.situacao_laudo === SITUACAO_LAUDO.SEM_LAUDO) ||
                            (temPermissaoRBAC(user, PERMISSOES.INVALIDAR_EXAME_LAUDADO) &&
                                exame.exame.situacao_laudo === SITUACAO_LAUDO.COM_LAUDO)) &&
                        invalidar &&
                        exame.exame.valido &&
                        <Invalidar
                            invalidar={invalidar}
                            setInvalidar={setInvalidar}
                            idExame={id}
                            idInstituicao={exame.exame.id_instituicao}
                            idModalidade={exame.exame.id_modalidade}
                            callback={voltarFn}
                        />
                    }
                    <SttCtrlP callback={callbackImpedirImpressao} />
                </>
            }
        </>
    )

}

export default DadosExame;